
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19","height":"19"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M-2-2h22v22H-2z"}}),_c('path',{attrs:{"fill":"#4A4A4A","fill-rule":"nonzero","d":"M10.833 7.167H7.167v3.666h3.666V7.167zm1.834 0v3.666h2.75V7.167h-2.75zm-1.834 8.25v-2.75H7.167v2.75h3.666zm1.834 0h2.75v-2.75h-2.75v2.75zM10.833 2.583H7.167v2.75h3.666v-2.75zm1.834 0v2.75h2.75v-2.75h-2.75zM5.333 7.167h-2.75v3.666h2.75V7.167zm0 8.25v-2.75h-2.75v2.75h2.75zm0-12.834h-2.75v2.75h2.75v-2.75zM1.667.75h14.666c.507 0 .917.41.917.917v14.666c0 .507-.41.917-.917.917H1.667a.917.917 0 01-.917-.917V1.667c0-.507.41-.917.917-.917z"}})])])
          )
        }
      }
    